import { useMemo } from "react";
import { ListWorkOrderScheduleDto } from "../models/workorderschedule.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredWorkOrderSchedules(schedules: ListWorkOrderScheduleDto[]) {
	const { query } = useSearch();

	const filteredSchedules = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return schedules?.filter(schedule =>
				(schedule.ScheduleName && schedule.ScheduleName.toLowerCase().includes(lowerQuery))
			) || [];
		}

		return schedules || [];
	}, [query, schedules]);

	return { filteredSchedules, showNoResults: query && query.length > 0 && filteredSchedules.length === 0 };
}
